












import { Vue, Component, Prop, Emit} from 'vue-property-decorator';
import { ICustomStylingClass } from './types/custom.t';
import type { ICustomsElementTypes } from './types/custom.t';

@Component
export default class CustomText extends Vue {

  @Prop({default: "p" })
  elementType?: ICustomsElementTypes;

  @Prop()
  customClass?: ICustomStylingClass[];

  @Prop()
  text?: string;

  @Prop()
  keyTranslation?: string;

  @Prop()
  href?: string;

  get translations() {
    return this.$store.state.translations.data;
  }

  @Emit('click')
  clickEvent() {}
}

